(function () {
  var bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  var config = window.__stickyAtcConfig;
  if (!config) return;

  var qty = 1;
  var selectedVariantId = config.variantId;
  var variants = config.variants;
  var inventoryMap = config.inventoryMap;
  var variantImageMap = config.variantImageMap;
  var fallbackImage = config.fallbackImage;
  var productAvailable = config.productAvailable;
  var bottomOffset = config.bottomOffset;
  var stockErrMsg = config.stockErrMsg;
  var addToCartText = config.addToCartText;
  var soldOutText = config.soldOutText;

  // Preload variant images
  Object.values(variantImageMap).forEach(function (src) {
    var img = new Image();
    img.src = src;
  });

  // -- Cart quantity cache --
  var cartQtyMap = {};

  function buildCartQtyMap(items) {
    cartQtyMap = {};
    (items || []).forEach(function (item) {
      cartQtyMap[item.variant_id] = (cartQtyMap[item.variant_id] || 0) + item.quantity;
    });
  }

  // Fetch once on load
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { buildCartQtyMap(cart.items); })
    .catch(function () {});

  // Sync from cart events (cart drawer qty change, cart update) — no extra fetch needed
  function onCartEvent(e) {
    if (e.detail && e.detail.response && e.detail.response.items) {
      buildCartQtyMap(e.detail.response.items);
    }
  }
  window.addEventListener('shapes:cart:cartqtychange', onCartEvent);
  window.addEventListener('shapes:cart:update', onCartEvent);

  // -- Visibility --
  function findAllBuyBtns() {
    return document.querySelectorAll(
      'button[name="add"], form[action*="cart/add"] button[type="submit"]'
    );
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  /* Changes Oscar 20-10:
     - Escritorio: la barra ya no sale al cargar tapando la zona de compra.
       (20-10 tarde) Sale siempre que el boton principal no este en pantalla, por encima o por debajo. Los botones de los carruseles de productos no cuentan.
     - (28-10) El chat se recoloca desde snippets/zd-chat-offset.liquid. */
  var barShown = false;

  function setBar(show) {
    barShown = show;
    bar.style.transform = show ? 'translateY(0)' : 'translateY(calc(100% + ' + bottomOffset + 'px + 2rem))';
  }

  function updateVisibility() {
    if (!productAvailable) { setBar(false); return; }

    var allBtns = findAllBuyBtns();
    if (!allBtns.length) { setBar(false); return; }

    var firstShown = null;
    for (var i = 0; i < allBtns.length; i++) {
      var btn = allBtns[i];
      if (btn.offsetParent === null || btn.closest('.product-slider__slide-atc, [class*="product-tile"]')) continue;
      if (!firstShown) firstShown = btn;
      if (isInViewport(btn)) { setBar(false); return; }
    }

    // Escritorio: aun no se ha llegado al boton principal (esta por debajo).
    if (false) {
      setBar(false); return;
    }

    // Mobile: hide at bottom of page
    if (window.innerWidth < 1024) {
      var scrollBottom = window.innerHeight + window.scrollY;
      if (false) { setBar(false); return; }
    }

    setBar(true);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
  updateVisibility();

  // -- Picker helpers --
  // Solo hay picker si el bloque product-picker-grid se ha renderizado
  // (expone window.ppgGetSelectedItems). Se evalúa en el momento de usarlo.
  function hasPicker() {
    return typeof window.ppgGetSelectedItems === 'function';
  }

  function hasSelfApi() {
    return typeof window.ppgGetSelfQuantity === 'function' && typeof window.ppgSetSelfQuantity === 'function';
  }

  // -- Quantity --
  var qtyDisplay = document.getElementById('sticky-atc-qty-display');
  var btnMinus = document.getElementById('sticky-atc-qty-minus');
  var btnPlus = document.getElementById('sticky-atc-qty-plus');
  var addBtn = document.getElementById('sticky-atc-btn');

  /* Changes Oscar 05-10: la cantidad de la barra fija es siempre la real.
     - Con selector de pack: las unidades de la propia ficha que hay en el
       pack (0 si no se ha añadido). +/- las cambian en el pack.
     - Sin selector (Reset): la del formato elegido (1, 2, 3 o 4 botes), y
       +/- avisan al formato y a la caja de suscripcion. */
  var minQty = 1;
  // Con selector de pack: unidades totales que se van a añadir (pack entero,
  // o 1 si esta vacio). `qty` sigue siendo la propia ficha, que es lo que
  // mueven + y -.
  var shownQty = null;

  function updateMinusState() {
    if (btnMinus) btnMinus.disabled = qty <= minQty;
  }

  function render() {
    var shown = shownQty != null && hasSelfApi() ? shownQty : qty;
    if (qtyDisplay) qtyDisplay.textContent = shown;
    if (addBtn) addBtn.dataset.qty = shown;
    updateMinusState();
  }

  function formatCents(cents) {
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  // Sin caja de suscripcion (Muestras) nadie copia el precio a la barra: se
  // pinta aqui el total del pack.
  function renderPackPrice(cents) {
    if (window.__stickyPriceMirrored || cents == null) return;
    var text = formatCents(cents);
    var sale = priceEl && priceEl.querySelector('.price-sale');
    if (sale) sale.textContent = text;
    var cmp = priceEl && priceEl.querySelector('.price-compare');
    if (cmp) cmp.remove();
    var mp = document.getElementById('sticky-mobile-price');
    if (mp && mp.style.display !== 'none') mp.textContent = text;
  }

  function setQty(n, broadcast) {
    minQty = hasSelfApi() ? 0 : 1;
    qty = Math.max(minQty, n | 0);
    render();
    hideStickyError();

    if (!broadcast) return;
    if (hasSelfApi()) {
      window.ppgSetSelfQuantity(qty);
    } else {
      document.dispatchEvent(new CustomEvent('product-qty-sync:changed', {
        detail: { quantity: qty, source: 'sticky', fromSticky: true, productId: config.productId }
      }));
    }
  }

  if (btnMinus) {
    btnMinus.addEventListener('click', function () {
      if (qty > minQty) setQty(qty - 1, true);
    });
  }

  if (btnPlus) {
    btnPlus.addEventListener('click', function () {
      if (hasSelfApi() && typeof window.ppgGetSelfMax === 'function' && qty >= window.ppgGetSelfMax()) return;
      setQty(qty + 1, true);
    });
  }

  document.addEventListener('ppg:quantity-changed', function (e) {
    var d = e.detail || {};
    if (d.selfQuantity == null) return;
    minQty = 0;
    qty = Math.max(0, Number(d.selfQuantity) || 0);
    if (d.displayQuantity != null) shownQty = Number(d.displayQuantity) || 0;
    render();
    renderPackPrice(d.displayPrice);
  });

  document.addEventListener('product-qty-sync:changed', function (e) {
    var d = e.detail || {};
    if (d.source === 'sticky' || d.quantity == null || hasSelfApi()) return;
    if (d.productId != null && config.productId != null && String(d.productId) !== String(config.productId)) return;
    qty = Math.max(1, Number(d.quantity) || 1);
    render();
  });
  if (typeof window.qfpGetQuantity === 'function' && !hasSelfApi()) {
    qty = Math.max(1, Number(window.qfpGetQuantity()) || 1);
    render();
  }

  // -- Variant selector --
  var variantSelect = document.getElementById('sticky-atc-variant');
  var priceEl = document.getElementById('sticky-atc-price');

  function getVariantById(id) {
    return variants.find(function (v) { return v.id == id; });
  }

  function updateVariant(id) {
    selectedVariantId = id;
    if (addBtn) addBtn.dataset.variantId = id;
    hideStickyError();
    var variant = getVariantById(id);

    var stickyImg = bar.querySelector('[data-sticky-image] img');
    if (stickyImg) {
      stickyImg.src = variantImageMap[id] || fallbackImage;
    }
    if (!variant) return;

    if (priceEl && !window.__stickyPriceMirrored) {
      var price = '€' + (variant.price / 100).toFixed(2).replace('.', ',');
      var html = '<span class="price-sale">' + price + '</span>';
      if (variant.compare_at_price > variant.price) {
        var comparePrice = '€' + (variant.compare_at_price / 100).toFixed(2).replace('.', ',');
        html += '<span class="price-compare">' + comparePrice + '</span>';
      }
      priceEl.innerHTML = html;
    }

    if (addBtn) {
      var surface = addBtn.querySelector('.push-btn__surface');
      addBtn.disabled = !variant.available;
      if (surface) surface.textContent = variant.available ? addToCartText : soldOutText;
    }

    var addBtnMobile = document.getElementById('sticky-atc-btn-mobile');
    if (addBtnMobile) {
      addBtnMobile.dataset.variantId = id;
      addBtnMobile.disabled = !variant.available;
      var labelEl = document.getElementById('sticky-mobile-label');
      if (labelEl) labelEl.textContent = variant.available ? addToCartText : soldOutText;
      var mobilePriceEl = document.getElementById('sticky-mobile-price');
      if (mobilePriceEl && !window.__stickyPriceMirrored) {
        var mPrice = (variant.price / 100).toFixed(2).replace('.', ',') + '€';
        mobilePriceEl.textContent = mPrice;
      }
    }

    updateVisibility();
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      updateVariant(this.value);
      var mainForm = document.querySelector('form[action*="cart/add"]');
      if (mainForm) {
        var mainVariantInput = mainForm.querySelector('[name="id"]');
        if (mainVariantInput) {
          mainVariantInput.value = this.value;
          mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('#sticky-atc-bar')) return;
    var mainForm = document.querySelector('form[action*="cart/add"]');
    if (!mainForm || !mainForm.contains(e.target)) return;
    var mainVariantInput = mainForm.querySelector('[name="id"]');
    if (!mainVariantInput) return;
    var newId = mainVariantInput.value;
    if (variantSelect) variantSelect.value = newId;
    updateVariant(newId);
  });

  // -- Error display --
  var errDesktop = document.getElementById('sticky-atc-error-desktop');
  var errMobile = document.getElementById('sticky-atc-error-mobile');
  var priceElSticky = document.getElementById('sticky-atc-price');

  function showStickyError(msg) {
    if (errDesktop) { errDesktop.textContent = msg; errDesktop.style.display = 'block'; }
    if (errMobile) { errMobile.textContent = msg; errMobile.style.display = 'block'; }
    if (priceElSticky) priceElSticky.style.display = 'none';
    setTimeout(hideStickyError, 4000);
  }

  function hideStickyError() {
    if (errDesktop) { errDesktop.textContent = ''; errDesktop.style.display = 'none'; }
    if (errMobile) { errMobile.textContent = ''; errMobile.style.display = 'none'; }
    if (priceElSticky) priceElSticky.style.display = '';
  }

  // -- Add to cart --
  var isBusy = false;

  function doAddToCart(stickyBtn) {
    if (!stickyBtn || stickyBtn.disabled || isBusy) return;

    // Unidades reales del producto principal (ver la nota de la cantidad).
    var extra = hasPicker() ? (window.ppgGetSelectedItems() || []) : [];
    var mainQty = qty;
    if (hasSelfApi()) {
      mainQty = Number(window.ppgGetSelfQuantity()) || 0;
      if (mainQty < 1 && !extra.length) mainQty = 1;
    } else if (typeof window.qfpGetQuantity === 'function') {
      mainQty = Number(window.qfpGetQuantity()) || qty;
    }

    var maxStock = inventoryMap[selectedVariantId];
    if (maxStock != null && mainQty > 0) {
      var inCart = cartQtyMap[selectedVariantId] || 0;
      if (inCart + mainQty > maxStock) {
        showStickyError(stockErrMsg);
        return;
      }
    }

    isBusy = true;
    stickyBtn.disabled = true;
    var surface = stickyBtn.querySelector('.push-btn__surface');
    var originalText = surface ? surface.textContent.trim() : '';
    if (surface) surface.textContent = '...';

    var mainForm = document.querySelector('.shopify-product-form');
    if (mainForm) {
      var mainVariantInput = mainForm.querySelector('[name="id"]');
      if (mainVariantInput) {
        mainVariantInput.value = selectedVariantId;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // -- Payload --
    var payload = {
      sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
      sections_url: window.location.pathname
    };
    var mainItem = { id: parseInt(selectedVariantId), quantity: mainQty };

    // Si está elegida la suscripción, plan de venta para el producto
    // principal (antes solo con picker: en Reset se añadia como compra única).
    var subBox = document.querySelector('[data-subscription-box]');
    var subActive = subBox && subBox.querySelector('.subscription-option--subscription.is-active');
    var planEl = subBox && subBox.querySelector('[data-selling-plan]');
    var sellingPlanId = (subActive && planEl && planEl.dataset.sellingPlan) || null;

    if (sellingPlanId) mainItem.selling_plan = parseInt(sellingPlanId, 10);
    
    var extraItems = extra.map(function (it) {
      var entry = { id: parseInt(it.id, 10), quantity: Number(it.quantity) || 1 };
      // Solo con plan si la variante lo tiene (botes de 70 tomas); si no, compra unica.
      var plan = it.selling_plan || (it.subscribable === false ? null : sellingPlanId);
      if (plan) entry.selling_plan = parseInt(plan, 10);
      return entry;
    });

    if (extraItems.length) {
      payload.items = mainItem.quantity > 0 ? [mainItem].concat(extraItems) : extraItems;
    } else {
      payload.id = mainItem.id;
      payload.quantity = mainItem.quantity;
      if (mainItem.selling_plan) payload.selling_plan = mainItem.selling_plan;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          showStickyError(stockErrMsg);
          if (inventoryMap[selectedVariantId] != null) inventoryMap[selectedVariantId] = 0;
          if (surface) surface.textContent = originalText;
          stickyBtn.disabled = false;
          isBusy = false;
          return;
        }
        hideStickyError();
        // Update local cart cache
        cartQtyMap[selectedVariantId] = (cartQtyMap[selectedVariantId] || 0) + mainQty;
        extra.forEach(function (it) {
          cartQtyMap[it.id] = (cartQtyMap[it.id] || 0) + it.quantity;
        });
        window.dispatchEvent(
          new CustomEvent('shapes:cart:afteradditem', {
            bubbles: true,
            detail: { response: result.data },
          })
        );
        if (hasPicker() && window.ppgResetSelectedItems) window.ppgResetSelectedItems();
        if (window.Alpine) {
          try { Alpine.store('modals').open('cart'); } catch (err) {}
        }
        if (surface) surface.textContent = originalText;
        stickyBtn.disabled = false;
        isBusy = false;
      })
      .catch(function () {
        if (surface) surface.textContent = originalText;
        stickyBtn.disabled = false;
        isBusy = false;
      });
  }

  // -- Button listeners --
  var btn1 = document.getElementById('sticky-atc-btn');
  var btn2 = document.getElementById('sticky-atc-btn-mobile');
  if (btn1) btn1.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); doAddToCart(this); });
  if (btn2) btn2.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); doAddToCart(this); });
})();
